import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  signal,
  TemplateRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RegistrationApprovalModel } from '../../../features/workshop/models/registration-approval.model';
import { ProfileService } from '../../../features/profile/services/profile.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-registration-approval-prompt',
  templateUrl: './registration-approval-prompt.component.html',
  styleUrls: ['./registration-approval-prompt.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class RegistrationApprovalPromptComponent implements OnInit, OnDestroy {
  @Input() template?: TemplateRef<any>;

  registrationApprovalProps = signal<RegistrationApprovalModel>(null);
  subscription: Subscription;

  constructor(private profileService: ProfileService) {}

  ngOnInit() {
    this.fetchMyApprovalStatus();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private fetchMyApprovalStatus() {
    this.subscription = this.profileService
      .getMyRegistrationApprovalStatus()
      .subscribe((resp) => {
        this.registrationApprovalProps.set(resp);
      });
  }
}
